export default "__VITE_PUBLIC_ASSET__3ff49bc4__"